import styled, { css } from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

interface IScTermsAndConditionsProps {
  isOpen: boolean;
  grayBg?: boolean;
  isTitleBtnOpacity?: boolean;
  isReverseArrow?: boolean;
}

export const ScTermsAndConditions = styled.div<IScTermsAndConditionsProps>`
  text-transform: none;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  max-width: ${({ grayBg }) => (grayBg ? '400px' : '600px')};
  ${({ grayBg, isOpen }) =>
    grayBg &&
    isOpen &&
    css`
      background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
      border-radius: 16px;
      .terms {
        padding: 0 12px 12px 12px;
      }
      @media (hover: hover) {
        &:hover {
          opacity: 0.8;
          transition: opacity 0.3s ease-in-out;
        }
      }
      margin-top: 8px;
    `}

  & > .terms__title {
    cursor: pointer;
    display: flex;
    justify-content: center;
    gap: 8px;
    ${({ grayBg }) =>
      grayBg &&
      css`
        margin-top: 12px;
        border-radius: 16px;
      `}

    & .arrow-wrapper {
      transform: rotate(${({ isOpen, isReverseArrow }) => (isOpen !== !!isReverseArrow ? '90deg' : '-90deg')});
      transition: transform 200ms;
      i {
        color: ${({ theme }) => theme.color2};
      }
    }

    ${({ isTitleBtnOpacity }) =>
      isTitleBtnOpacity &&
      css`
        color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
        .arrow-wrapper {
          height: 16px;
          i {
            color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
          }
        }
        &:hover {
          color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.8)};
          i {
            color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.8)};
          }
        }
      `}
  }

  & .terms {
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows ${({ isOpen }) => (isOpen ? '0.4s' : '0.2s')}
      ease;

    ${({ grayBg, isOpen }) =>
      grayBg &&
      isOpen &&
      css`
        padding: 12px;
        margin-top: 8px;
        .terms:hover {
          background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.3)};
        }
      `}

    &-content {
      overflow: hidden;
      & ol {
        padding-left: ${({ grayBg }) => (grayBg ? '26px' : '16px')};
        text-align: left;
        margin-top: ${({ grayBg }) => (grayBg ? '0px' : '8px')};
        & li {
          &:not(:last-child) {
            margin-bottom: ${({ grayBg }) => (grayBg ? '18px' : '10px')};
          }
        }
      }
    }
  }
`;
